import { connectedRouterRedirect } from 'redux-auth-wrapper/history3/redirect'
import { routerActions } from 'react-router-redux';
import { accountRoles } from '../../../common/enums';
import { selectIsInProgress } from '../../../features/spinner/ducks';
import { apiCallIds } from '../api';
import { selectAccount } from '../ducks';

export default connectedRouterRedirect({
  authenticatedSelector: state => selectAccount(state) &&
    (selectAccount(state).role === accountRoles.CREDITOR || selectAccount(state).role === accountRoles.DEBTOR || selectAccount(state).role === accountRoles.EXECUTOR),
  authenticatingSelector: state => selectIsInProgress(state, apiCallIds.LOGIN),
  redirectPath: state => (selectAccount(state) ? '/' : '/auth/login'),
  redirectAction: routerActions.replace,
  wrapperDisplayName: 'IsUser',
});



// WEBPACK FOOTER //
// ./src/features/auth/utils/IsUser.js